<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { getSession } from "@/utils/auth";
import { mapActions, mapState } from "vuex";

export default {
    name: "App",
    computed: {
        ...mapState("userAuth", ["user"]),
    },
    watch: {
        // Bootstrap reactivo: cuando user.email cambia (page-load con session
        // existente O post-login en navegación SPA), disparamos getUserInfo
        // para llenar user_info_loaded. Cubre ambos casos sin depender de
        // App.vue.created() — que sólo corre una vez por page-load y no
        // re-dispara después de logout/login dentro de la misma sesión SPA.
        "user.email": {
            handler(email, oldEmail) {
                if (email && email !== oldEmail) {
                    const companyId = this.getCompanyIdFromHashUrl();
                    this.getUserInfo({ email, companyId });
                    this.getIfHasNewDocs();
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions("userAuth", [
            "setLoginInfo",
            "getUserInfo",
        ]),
        ...mapActions("classification", ["getIfHasNewDocs"]),
        getCompanyIdFromHashUrl() {
            const hash = window.location.hash;
            const queryString = hash.includes("?") ? hash.split("?")[1] : "";
            const params = new URLSearchParams(queryString);
            return params.get("company_id") || null;
        },
    },
    created() {
        // Bootstrap inicial sólo si hay session en localStorage. setLoginInfo
        // dispara SET_LOGIN que puebla state.user con el email — eso activa
        // el watcher de arriba, que se encarga del getUserInfo + getIfHasNewDocs.
        // (No llamar clearUserInfo aquí: ese action dispara /logout/ que
        // devuelve 401 sin token y el interceptor recarga la página → loop.)
        // El redirect a "/" cuando no hay session lo hace el guard del router
        // sólo para rutas con requiresAuth; no forzarlo acá para no pisar
        // rutas públicas (registers, recovery, confirm, thankyou, etc.).
        const session = getSession();
        if (session) {
            this.setLoginInfo(session);
        }
    },
};
</script>

<style lang="scss">
@import "./assets/style";
</style>
